module.exports = __webpack_public_path__ + "static/media/anti-inflamatorio-icon.f334b706.png";